// extracted by mini-css-extract-plugin
module.exports = {"LikeControl__btn":"hu_a"};